import { Save } from "lucide-react";
import { Button } from "./button";

const SubmitButton = ({ loading }: { loading: boolean }) => {
  return (
    <Button
      type="submit"
      className="flex items-center space-x-2 bg-primary-500 dark:bg-primary-400 text-white dark:hover:opacity-90"
      disabled={loading}
      variant="outline"
    >
      <Save className="w-4 h-4" />
      <span>Salvar</span>
    </Button>
  );
};

export { SubmitButton };
